import { RippleGlobalOptions } from "@angular/material/core";

export const globalRippleConfig: RippleGlobalOptions = {
    disabled: false,
    animation: {
        enterDuration: 300,
        exitDuration: 100
    },
}
